/** Per-user recently-picked records, kept in localStorage. Used to surface and
 * rank recent choices in search dropdowns (e.g. the submission composer's
 * merchant picker). Local to this browser — not synced across devices. */

export interface RecentRecord {
  id: string;
  label: string;
  ts: number;
}

const MAX_RECENTS = 15;

function storageKey(table: string, userId: string): string {
  return `sky_recent_${table}_${userId}`;
}

export function getRecentRecords(table: string, userId: string | undefined): RecentRecord[] {
  if (!userId) return [];
  try {
    const raw = localStorage.getItem(storageKey(table, userId));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function pushRecentRecord(table: string, userId: string | undefined, item: { id: string; label: string }): void {
  if (!userId || !item.id) return;
  try {
    const list = getRecentRecords(table, userId).filter(r => r.id !== item.id);
    list.unshift({ id: item.id, label: item.label, ts: Date.now() });
    localStorage.setItem(storageKey(table, userId), JSON.stringify(list.slice(0, MAX_RECENTS)));
  } catch {
    // localStorage full/blocked — recents are a nicety, ignore.
  }
}

/** Stable rank map: id → recency index (0 = most recent). */
export function recentRankMap(table: string, userId: string | undefined): Map<string, number> {
  return new Map(getRecentRecords(table, userId).map((r, i) => [r.id, i]));
}
